module.exports = __webpack_public_path__ + "static/media/sell_take_order_help_4.e7798f72.png";